import { render, staticRenderFns } from "./Item8.vue?vue&type=template&id=13f07e74&scoped=true&"
import script from "./Item8.vue?vue&type=script&lang=js&"
export * from "./Item8.vue?vue&type=script&lang=js&"
import style0 from "./Item8.vue?vue&type=style&index=0&id=13f07e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f07e74",
  null
  
)

export default component.exports